// src/data/resources/articleIndex.ts (renamed from articles.ts)

// Import individual category article files
import { gettingStartedArticles } from './articles/getting-started';
import { featuresSettingsArticles } from './articles/features-settings';
import { bestPracticesArticles } from './articles/best-practices';
import { emailProviderArticles } from './articles/email-provider-integration';
import { accountBillingArticles } from './articles/account-billing';
import { troubleshootingArticles } from './articles/troubleshooting';

// Combine all articles into a single array
export const articles = [
  ...gettingStartedArticles,
  ...featuresSettingsArticles,
  ...bestPracticesArticles,
  ...emailProviderArticles,
  ...accountBillingArticles,
  ...troubleshootingArticles
];

// Export individual category article arrays
export {
  gettingStartedArticles,
  featuresSettingsArticles,
  bestPracticesArticles,
  emailProviderArticles,
  accountBillingArticles,
  troubleshootingArticles
};